import NProgress from 'nprogress'

NProgress.configure({ showSpinner: false })

export function cancelTopProgress () {
  NProgress.done()
}
function tryInitProgress () {
  NProgress.start()
}
export default function initProgress (router) {
  router.afterEach(cancelTopProgress)
  router.beforeEach((to, from, next) => {
    if (to.path) {
      tryInitProgress()
    }
    const publicPages = ['/login']
    const authRequired = !publicPages.includes(to.path)
    const loggedInToken = localStorage.getItem('token')
    const loggedInRole = localStorage.getItem('role')

    if (authRequired && !loggedInToken && !loggedInRole) {
      next('/login')
    } else if (!authRequired && loggedInToken && loggedInRole) {
      next('/')
    }
    return next()
  })
}



// WEBPACK FOOTER //
// ./src/helpers/nprogress-bar.js